import React from 'react';
import './pagestyles/Politics.css';
import BottomBanner from './BottomBanner';

const Politics = () => {
  return (
      <>
    <div className="page-container">
      <div className="page-header">
        <h1>Politics</h1>
        <p className="page-subtitle">Government policy, regulation, and political developments</p>
      </div>
      
      <div className="page-content">
        <div className="content-grid">
          <a href="/article/new-trade-policies-announced" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=600&h=400&fit=crop" alt="Government building" />
              </div>
              <div className="article-content">
               
                <h2>New Trade Policies Announced</h2>
                <p>Government unveils comprehensive trade policy reforms aimed at boosting international commerce.</p>
                <span className="article-meta">1 hour ago</span>
              </div>
            </article>
          </a>

          <a href="/article/climate-legislation-gains-momentum" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1495573258723-2c7be7a646ce?w=600&h=400&fit=crop" alt="Climate policy" />
              </div>
              <div className="article-content">
              
                <h2>Climate Legislation Gains Momentum</h2>
                <p>Lawmakers advance ambitious climate bills with bipartisan support in major economies.</p>
                <span className="article-meta">3 hours ago</span>
              </div>
            </article>
          </a>

          <a href="/article/healthcare-reform-proposals-debated" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1593115057322-e94b77572f20?w=600&h=400&fit=crop" alt="Healthcare policy" />
              </div>
              <div className="article-content">
                
                <h2>Healthcare Reform Proposals Debated</h2>
                <p>Policymakers discuss sweeping healthcare reforms to improve access and reduce costs.</p>
                <span className="article-meta">5 hours ago</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>

      <BottomBanner />
        </>
  );
};

export default Politics;
